import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-collective-entreprise',
  standalone: true,
  imports: [CommonModule, PageLayoutComponent],
  templateUrl: './assurance-collective-entreprise.component.html',
  styleUrls: ['./assurance-collective-entreprise.component.scss']
})
export class AssuranceCollectiveEntrepriseComponent {
  title = 'Assurance Mutuelle Santé Entreprise';
  subtitle = '';
  heroVideo = 'assets/videos/sante.mp4';
  
  breadcrumbs = [
    { label: 'Entreprises', link: undefined },
    { label: 'Assurance Santé', link: undefined }
  ];

  prevPage = { title: 'Assurance Mutuelle Santé Internationale Professionnelle',
    link: '/assurance-mutuelle-sante-internationale-pro'
  };

  nextPage = { title: 'Assurance Prévoyance Professionnelle',
    link: '/assurance-prevoyance-professionnelle'
  };

  partners = [
    { name: 'GENERALI', logo: 'assets/logos/GENERALI.PNG' },
    { name: 'APRIL', logo: 'assets/images/logos/april-logo.png' },
    { name: 'ALPTIS', logo: 'assets/logos/ALPTIS.PNG' },
    { name: 'SWISSLIFE', logo: 'assets/logos/SWISSLIFE.PNG' },
    { name: 'MALAKOFF HUMANIS', logo: 'assets/logos/MALAKOFF.PNG' },
    { name: 'SPVIE', logo: 'assets/logos/SPIVE.PNG' },
    { name: 'HENNER', logo: 'assets/logos/HENNER.PNG' },
    { name: 'APIVIA', logo: 'assets/logos/APIVIA.PNG' }
  ];

  constructor(private router: Router) {}

  navigateToContact() {
    this.router.navigate(['/contactez-nous']);
  }
}
